import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useEffect, useState } from "react";
import apiService from "../services/apiService";

export default function PDFViewer({ qSetId }) {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!qSetId) return;

    let isMounted = true;

    const fetchPdfUrl = async () => {
      setLoading(true);
      setErrorMsg("");

      try {
        const response = await apiService.request(`/i/ims/aiqset/${qSetId}`, {
          method: "GET",
        });

        const qSet = response?.data || response || {};
        const pdfUrl = qSet?.pdfUrl || "";

        console.log("QSet ID:", qSetId);
        console.log("QSet Data:", qSet);
        console.log("PDF URL from qSet:", pdfUrl);

        if (!isMounted) return;

        if (!pdfUrl) {
          setUrl("");
          setErrorMsg("PDF URL not found in qSet");
          return;
        }

        setUrl(pdfUrl);
      } catch (error) {
        console.log("PDF URL fetch failed:", error);

        if (!isMounted) return;

        setUrl("");
        setErrorMsg("PDF URL fetch failed");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPdfUrl();

    return () => {
      isMounted = false;
    };
  }, [qSetId]);

  return (
    <div className="h-screen overflow-y-auto">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        {loading ? (
          <p>Loading PDF...</p>
        ) : url ? (
          <Viewer fileUrl={url} />
        ) : (
          <p>{errorMsg || "PDF not found"}</p>
        )}
      </Worker>
    </div>
  );
}
